import { BodyText, Button, Strong } from '@utilitywarehouse/hearth-react';
import { FC } from 'react';

import { Dialog, DialogActions, DialogID, useDialog } from '@components/Dialog';
import {
  AppointmentParticipant,
  ControlRequestedEvent,
} from '@generated/gql/graphql';

interface ControlRequestDialogProps {
  controlRequest: ControlRequestedEvent;
  setController: (participant: AppointmentParticipant) => void;
  deny: (request: ControlRequestedEvent) => void;
}

interface ControlRequestDialogUIProps {
  dialogId: DialogID;
  participantName: string;
  onDeny: () => void;
  onGiveControl: () => void;
}

const ControlRequestDialogUI = ({
  dialogId,
  participantName,
  onDeny,
  onGiveControl,
}: ControlRequestDialogUIProps) => (
  <Dialog
    id={dialogId}
    heading={`${participantName} would like screen control`}
    preventDismiss
    hideCloseButton
  >
    <BodyText>
      Would you like to give control to <Strong>{participantName}</Strong>, or
      keep your screen control?
    </BodyText>
    <DialogActions ignoreControl>
      <Button variant="outline" onClick={onDeny}>
        Keep control
      </Button>
      <Button variant="solid" onClick={onGiveControl}>
        Give control to {participantName}
      </Button>
    </DialogActions>
  </Dialog>
);

const ControlRequestDialog: FC<ControlRequestDialogProps> = ({
  controlRequest,
  setController,
  deny,
}) => {
  const dialog = useDialog(DialogID.APMT_REQUEST_CONTROL);

  return (
    <ControlRequestDialogUI
      dialogId={dialog.id}
      participantName={controlRequest.fromParticipant.name}
      onDeny={() => deny(controlRequest)}
      onGiveControl={() => setController(controlRequest.fromParticipant)}
    />
  );
};

export type { ControlRequestDialogProps, ControlRequestDialogUIProps };

export { ControlRequestDialog, ControlRequestDialogUI };
